import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { getMoreInCategoriesLinks } from 'site-modules/editorial/utils/entry-converter';
import { ArticleMenu } from 'site-modules/shared/components/editorial/article-menu/article-menu';

const MORE_LINKS_NUMBER = 3;

export function ArticleLinks({ entry, canonical }) {
  const articleMenuLinksEntry = entry.child('links');
  const articleMenuLinks = getMoreInCategoriesLinks(
    canonical,
    articleMenuLinksEntry.children(),
    false,
    MORE_LINKS_NUMBER
  );
  const articleMenuTitle = articleMenuLinksEntry.metadata('moduleHeader').value();

  return <ArticleMenu className="mb-1_5" title={articleMenuTitle} links={articleMenuLinks} dividerClassName="d-none" />;
}

ArticleLinks.propTypes = {
  entry: CmsEntities.Content.isRequired,
  canonical: PropTypes.string.isRequired,
};
